module.exports = __webpack_public_path__ + "img/底座1 拷贝 3.61790cf2.png";